import { BBCRiskAnalysisRow } from "./ReportingRows/bbc-risk-analysis-row";
import { MissedAuditRow } from "./ReportingRows/missed-audit-row";
import { MonthlyActionsRow } from "./ReportingRows/monthly-actions-row";
import { MonthlyAuditCompletionRow } from "./ReportingRows/monthly-audit-completion-row";
import { NonComplianceRow } from "./ReportingRows/non-compliance-row";

export class ReportData{
    public ReportID:number = -1;
    public NonComplianceRows:NonComplianceRow[] = [];
    public MissedAuditRows:MissedAuditRow[]=[];
    public RiskAnalysisRows:BBCRiskAnalysisRow[]=[];
    public MonthlyAuditCompletionRows: MonthlyAuditCompletionRow[] = [];
    public MonthlyActionsRows: MonthlyActionsRow[] = [];
    public ExportSummary:boolean = false;
    public ExportFullDetails:boolean = false;
    constructor(values: Object = {}){
        Object.assign(this, values);
        if (values.hasOwnProperty('NonComplianceRows')) {
            this.NonComplianceRows = [];
            ((values as ReportData)['NonComplianceRows'] as NonComplianceRow[]).forEach(element => {
                this.NonComplianceRows.push(new NonComplianceRow(element));
            });
        }
        if (values.hasOwnProperty('MissedAuditRows')) {
            this.MissedAuditRows = [];
            ((values as ReportData)['MissedAuditRows'] as MissedAuditRow[]).forEach(element => {
                this.MissedAuditRows.push(new MissedAuditRow(element));
            });
        }
        if (values.hasOwnProperty('RiskAnalysisRows')) {
            this.RiskAnalysisRows = [];
            ((values as ReportData)['RiskAnalysisRows'] as BBCRiskAnalysisRow[]).forEach(element => {
                this.RiskAnalysisRows.push(new BBCRiskAnalysisRow(element));
            });
        }
        if (values.hasOwnProperty('MonthlyAuditCompletionRows')) {
            this.MonthlyAuditCompletionRows = [];
            ((values as ReportData)['MonthlyAuditCompletionRows'] as MonthlyAuditCompletionRow[]).forEach(element => {
                this.MonthlyAuditCompletionRows.push(new MonthlyAuditCompletionRow(element));
            });
        }
        if (values.hasOwnProperty('MonthlyActionsRows')) {
            this.MonthlyActionsRows = [];
            ((values as ReportData)['MonthlyActionsRows'] as MonthlyActionsRow[]).forEach(element => {
                this.MonthlyActionsRows.push(new MonthlyActionsRow(element));
            });
        }
    }
}
